// The agent's phone and the call engine (Stage 4.8f.2): their live calls, and transfers done by the engine (server/ai/phoneRoutes.js).
import axiosInstance from "../../../services/axiosInstance";

const unwrap = (p) => p.then(({ data }) => data);

export const myLiveCalls = () => unwrap(axiosInstance.get("/phone/calls"));
// action: transfer { to: "ext:41031" | "dept:Sales" | "tel:+962…", mode: "blind" | "attended" } | complete | cancel | swap
export const callAction = (id, action, body = {}) => unwrap(axiosInstance.post(`/phone/calls/${encodeURIComponent(id)}/${action}`, body));
export const transferTargets = () => unwrap(axiosInstance.get("/phone/targets"));

// What was typed, as a transfer target: an extension's digits, else a number outside.
export const targetOf = (typed) => {
  const s = String(typed ?? "").trim();
  if (/^(ext|dept|tel):/.test(s)) return s;
  return /^\d{2,8}$/.test(s) ? `ext:${s}` : `tel:${s}`;
};

// The new phone's desk (Stage 4.8f.4a, server/ai/phoneDesk.js).
export const checkNumber     = (to) => unwrap(axiosInstance.get("/phone/check", { params: { to } }));
export const recentCalls     = () => unwrap(axiosInstance.get("/phone/recent"));
export const favourites      = () => unwrap(axiosInstance.get("/phone/favourites"));
export const addFavourite    = (f) => unwrap(axiosInstance.post("/phone/favourites", f));
export const removeFavourite = (id) => unwrap(axiosInstance.delete(`/phone/favourites/${encodeURIComponent(id)}`));
export const setCallerId     = (number) => unwrap(axiosInstance.put("/phone/caller-id", { number: number || null }));
// Customers, as the CRM lets this person see them.
export const searchCustomers = (q) => unwrap(axiosInstance.get("/crm/v2/contacts", { params: { q, limit: 20, page: 1 } }));
